// eslint-disable-next-line import/prefer-default-export
export const isEmpty = (value: unknown) => value === null
  || value === undefined
  || value === ''
  || (Array.isArray(value) && value.length === 0)
